<template>
  <v-list v-if="prev[0] || next[0]" dense>
    <v-list-tile
      v-for="phase in next"
      :key="`next-${phase.id}`"
      @click.stop="confirmPrompt(phase)"
      :disabled="disabled"
    >
      <v-list-tile-content>
        <v-list-tile-title class="subheading">{{
          phase.name
        }}</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action :style="disabled ? 'opacity: 0.5;' : ''">
        <v-icon :color="!disabled ? themes.client.light.success : ''">
          mdi-arrow-right-bold
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile
      v-for="phase in prev"
      :key="`prev-${phase.id}`"
      @click.stop="confirmPrompt(phase)"
      :disabled="disabled"
    >
      <v-list-tile-content>
        <v-list-tile-title class="subheading">{{
          phase.name
        }}</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action :style="disabled ? 'opacity: 0.5;' : ''">
        <v-icon :color="!disabled ? themes.client.light.warning : ''">
          mdi-arrow-left-bold
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile
      v-if="canRegret"
      :disabled="!(applications || applications[0])"
      @click.stop="confirmPrompt({ name: 'Unsuccessful' })"
    >
      <v-list-tile-content>
        <v-list-tile-title class="subheading">Regret</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action
        :style="!(applications[0] && applications) ? 'opacity: 0.5;' : ''"
      >
        <v-icon>mdi-account-off</v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-dialog v-model="confirming" max-width="500px">
      <v-card>
        <v-card-title> Confirm </v-card-title>
        <v-card-text v-if="newPhase && newPhase.name">
          Please confirm that you would like to move
          <span v-if="applications.length">
            <strong>{{ applications.length }}</strong>
            {{ applications.length | pluralize("candidate") }}
          </span>
          <span
            v-else-if="applications.profile && applications.profile.firstName"
          >
            <strong>{{ applications.profile.firstName }}</strong>
          </span>
          <span v-else>candidate(s)</span>
          to <strong>{{ newPhase.name }}</strong
          >?
        </v-card-text>
        <v-card-actions v-if="newPhase">
          <v-spacer />
          <v-btn
            :color="themes.client.light.cancel"
            flat
            @click.stop="confirming = false"
          >
            Cancel
          </v-btn>
          <v-btn
            @click.stop="newPhase.name == 'Unsuccessful' ? regret() : move()"
            :color="themes.client.light.primaryActionButton"
            :disabled="busy"
            :loading="busy"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list>
</template>

<script>
import _ from "lodash";

export default {
  created() {
    if (
      _.get(this, "opportunity.id") &&
      !_.get(this, "opportunity.phases[0]")
    ) {
      this.$store.dispatch("client/opportunities/fetch", this.opportunity.id);
    }
  },

  props: {
    applications: [Array, Object],
    includeRegret: { type: Boolean, default: false },
    opportunity: Object,
  },

  data() {
    return {
      confirming: false,
      newPhase: null,
      busy: false,
    };
  },

  computed: {
    opportunityStore() {
      const id = _.get(this, "opportunity.id") || this.$route.params.id;
      return this.$store.getters["client/opportunities/find"](id);
    },

    phases() {
      const id = _.get(this, "opportunity.id") || this.$route.params.id;
      return this.$store.getters["client/opportunities/orderedPhases"](id);
    },

    current() {
      let status = null;
      if (this.applications && this.applications.status) {
        status = this.applications.status;
      }
      if (this.applications && this.applications[0]) {
        status = this.$store.getters["client/applications/find"](
          this.applications[0]
        ).status;
      }
      if (status) {
        return {
          name: status,
          index: this.phases.findIndex((p) => status === p.name),
        };
      }
      return {};
    },

    prev() {
      if (this.current && this.current.index > 0) {
        return this.phases.slice(0, this.current.index);
      }
      return [];
    },

    next() {
      const length = this.phases.length;
      if (this.current && this.current.index < length) {
        return this.phases.slice(this.current.index + 1);
      }
      return this.phases;
    },

    canRegret() {
      return (
        this.includeRegret &&
        this.current &&
        this.current.name !== "Unsuccessful"
      );
    },

    disabled() {
      return (
        Object.keys(this.applications).length === 0 &&
        this.applications.length === 0
      );
    },
  },
  methods: {
    confirmPrompt(phase) {
      this.$nextTick(() => {
        this.newPhase = phase;
        this.confirming = true;
      });
    },

    move() {
      this.busy = true;
      this.$store
        .dispatch("client/applications/move", {
          applications: this.applications,
          phase: this.newPhase,
        })
        .then(
          () => {
            this.$store.dispatch("snackbarSuccess", "Moved successfully");
            this.$emit("done", this.newPhase);
            this.confirming = false;
            return this.$store.dispatch(
              "client/applications/updateFilters",
              {}
            );
          },
          () => {
            this.confirming = false;
            return this.$store.dispatch(
              "snackbarError",
              "No application was moved"
            );
          }
        )
        .finally(() => (this.busy = false));
    },

    regret() {
      this.busy = true;
      this.$store
        .dispatch("client/applications/regret", {
          applications: this.applications,
        })
        .then(
          () =>
            this.$store.dispatch("snackbarSuccess", "Marked as unsuccessful"),
          () => this.$store.dispatch("snackbarError", "No change was made")
        )
        .then(() => {
          this.confirming = false;
          this.$emit("done");
          return this.$store.dispatch("client/applications/updateFilters", {});
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
